/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Status des annonces immobilières :\n- PENDING: En attente de mandat\n- ACTIVE: En vente/location\n- COMPLETED: Vendu/Loué\n- ARCHIVED: Archivé\n- STANDBY: Suspendu\n
 */
export const statePropertySchema = z.enum(["PENDING", "ACTIVE", "COMPLETED", "ARCHIVED", "STANDBY"]).describe("Status des annonces immobilières :\n- PENDING: En attente de mandat\n- ACTIVE: En vente/location\n- COMPLETED: Vendu/Loué\n- ARCHIVED: Archivé\n- STANDBY: Suspendu\n")